import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, MessageCircle, ArrowLeft } from 'lucide-react';
import { bakeryInfo } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const LoginPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex items-center justify-center relative" style={{ background: 'linear-gradient(135deg, #1a5c1a 0%, #2d7a2d 100%)' }}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }} className="w-full h-full" />
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 py-12">
        {/* Back Button */}
        <button
          onClick={() => navigate('/')}
          className="mb-8 flex items-center gap-2 text-white hover:text-yellow-300 transition-colors"
          data-testid="back-to-home-btn"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>{t.login?.backToHome || 'العودة للرئيسية'}</span>
        </button>

        {/* Logo */}
        <div className="text-center mb-12">
          <img 
            src={bakeryInfo.logo} 
            alt="Dura Alsham"
            className="w-24 h-24 object-contain mx-auto mb-4"
          />
          <h1 className="text-4xl font-bold text-white mb-2" style={{ fontFamily: 'Playfair Display' }}>
            {t.login?.welcome || 'مرحباً بك'}
          </h1>
          <p className="text-white/80 text-lg">
            {t.login?.chooseMethod || 'اختر طريقة تسجيل الدخول المفضلة لديك'}
          </p>
        </div>

        {/* Login Options */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Email Login */}
          <button
            onClick={() => navigate('/register/email')}
            className="group bg-white rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 hover:scale-105"
            data-testid="email-login-btn"
          >
            <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center transition-all duration-300" style={{ background: 'linear-gradient(135deg, #1a5c1a 0%, #2d7a2d 100%)' }}>
              <Mail className="w-10 h-10 text-white" />
            </div>
            <h3 className="text-2xl font-bold mb-3" style={{ fontFamily: 'Playfair Display', color: '#1a5c1a' }}>
              {t.login?.emailLogin || 'تسجيل الدخول بالإيميل'}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {t.login?.emailDesc || 'قم بإنشاء حساب جديد أو تسجيل الدخول باستخدام البريد الإلكتروني وكلمة المرور'}
            </p>
            <div className="mt-6 flex items-center justify-center gap-2 text-green-700 font-semibold group-hover:gap-3 transition-all">
              <span>{t.login?.startNow || 'ابدأ الآن'}</span>
              <ArrowLeft className="w-5 h-5 transform rotate-180" />
            </div>
          </button>

          {/* WhatsApp Login */}
          <button
            onClick={() => navigate('/b2b/login')}
            className="group bg-white rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 hover:scale-105"
            data-testid="whatsapp-login-btn"
          >
            <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center transition-all duration-300" style={{ background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)' }}>
              <MessageCircle className="w-10 h-10 text-white" />
            </div>
            <h3 className="text-2xl font-bold mb-3" style={{ fontFamily: 'Playfair Display', color: '#1a5c1a' }}>
              {t.login?.whatsappLogin || 'تسجيل الدخول بالواتساب'}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {t.login?.whatsappDesc || 'تسجيل دخول سريع وآمن باستخدام رقم الواتساب الخاص بك'}
            </p>
            <div className="mt-6 flex items-center justify-center gap-2 text-green-700 font-semibold group-hover:gap-3 transition-all">
              <span>{t.login?.startNow || 'ابدأ الآن'}</span>
              <ArrowLeft className="w-5 h-5 transform rotate-180" />
            </div>
          </button>
        </div>

        {/* Note */}
        <p className="text-center text-white/70 mt-12 max-w-2xl mx-auto">
          {t.login?.haveAccount || 'لديك حساب بالفعل؟ اختر طريقة الدخول المناسبة لمتابعة طلباتك وإدارة حسابك'}
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
